import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import UserForm from "../../components/forms/UserForm.jsx";
import { api } from "../../utils/apiClient";
import { toast } from 'react-toastify';

const EditUserPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state ?? [];

  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get(`/users/${id}`);
        setInitialData(res.data.data);  // FIX
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  const handleUpdateUser = async (formData) => {
    try {
      let payload;
      let headers;

      // Convert numeric fields
      const cleanData = { ...formData };
      cleanData.role_id =
        cleanData.role_id === "" || cleanData.role_id === null
          ? null
          : Number(cleanData.role_id);
      // cleanData.insurance_id =
      //   cleanData.insurance_id === "" || cleanData.insurance_id === null
      //     ? null
      //     : Number(cleanData.insurance_id);

      // Remove empty password
      if (!cleanData.password) delete cleanData.password;

      if (cleanData.icon) {
        // Use FormData if file is uploaded
        payload = new FormData();
        Object.keys(cleanData).forEach((key) => {
          if (cleanData[key] !== null) payload.append(key, cleanData[key]);
        });
        headers = { "Content-Type": "multipart/form-data" };
      } else {
        // Send JSON if no file
        payload = cleanData;
        delete payload.icon; // remove null
        headers = { "Content-Type": "application/json" };
      }

      const res = await api.put(`/users/${id}`, payload, { headers });

      if (res.status === 200) {
        toast.success("User updated successfully!");
        navigate("/users");
      }
    } catch (error) {
      console.log("Update error:", error.response?.data || error.message);
      toast.error("Update failed!");
    }
  };


  if (loading) return <p>Loading user data...</p>;

  return (
    <>
      <Breadcrumb title="User Management" />
      <UserForm onSubmit={handleUpdateUser} initialData={initialData} roleName={data} />
    </>
  );
};

export default EditUserPage;
